<template>
    <div>
    <b-jumbotron align="left"  fluid class="mb-0" :style="{backgroundSize: 'cover',backgroundImage: $store.state.globalTheme.HOMEPAGE_IMAGE}">
     <template v-slot:lead>
       <h3 style="margin-left: 4%;" class="text-light" v-html="$store.state.globalTheme.HOMEPAGE_TITLE"></h3>
      </template>
         <div style="margin-left: 4%;">
            <p class="text-light mb-sm-1 mb-lg-2 mb-md-1">{{ $store.state.globalTheme.HOMEPAGE_SUBTITLE }}</p>
           <b-col class="px-0 py-lg-2">
         <b-button :to="{name:'gallery'}" :style="{backgroundColor:$store.state.globalTheme.DEFAULT_COLOR, borderColor: $store.state.globalTheme.DEFAULT_COLOR}" size="lg" >Get Started</b-button>
             </b-col>
          </div>
      </b-jumbotron>
      <b-container><br>
      <b-row align-h="center" class="mb-2">
        <b-col cols="12" class="mb-2">
          <h3>Top Picks</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-container fluid>
          <carousel :centerMode="true" :navigationEnabled="true" :paginationEnabled="false" :perPageCustom="[[576, 3],[768, 4],[992, 4]]" :navigationClickTargetSize="1">
            <slide v-for="s in items" :key="s.id">
              <Highlight :name="s.name" :logo="s.logo" :id="s.id" />
            </slide>
          </carousel>
        </b-container>
      </b-row>

    <JoinToday :title="$store.state.globalTheme.JOIN_HEADER"/>

    <b-row align-h="center" style="margin-top: 1rem; margin-bottom: 1:rem;">
        <b-col cols="11" style="margin-bottom: 1.5rem;">
      <h3>Browse By {{ $store.state.globalTheme.AREA_ALIAS }}</h3>
        </b-col>
    </b-row>

<b-row align-h="center" style="margin-left: 0.75rem; margin-right: 0.75rem;">
  <Area v-for="area in areas.slice(0,6)" :key="area.id" :name="area.name" :id="area.id" :image="area.image"/>
  <b-button :to="{name:'areas'}" block :style="{backgroundColor:$store.state.globalTheme.DEFAULT_COLOR, borderColor: $store.state.globalTheme.DEFAULT_COLOR}" class="mx-3">View All</b-button>
  </b-row>
      <b-row align-h="center" style="margin-top: 1rem; margin-bottom: 1:rem;">
        <b-col cols="11">
      <p>{{ $store.state.globalTheme.HOMEPAGE_PARAGRAPH }}</p>
        </b-col>
    </b-row>
     </b-container>
</div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  import Highlight from "./Highlight.vue";
  import Area from "./Area.vue";
  import { getAPI } from '../store/axios-base'
  import JoinToday from "./JoinToday.vue";
    export default {
        name: "Home.vue",
        data:() => {
          return {
              items: [],
              areas: []
          }
          },
          mounted:function(){
          this.FetchData(1,'');
        },
        methods: {
            FetchData: function () {
                var headers = {}

                getAPI.get("/api/v1/sessions/?highlight=true", {headers: headers}).then(response => {
                    console.log(response);
                    this.items = response.data.items
                    this.areas = response.data.areas
                });

            },
        },
        components: {
          Carousel,
          Slide,
          Highlight,
          Area,
          JoinToday
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue